<div class="spinner-overlay" *ngIf="authService.loading$ | async">
  <span class="loader"></span>
</div>